import React, { useState, useEffect, useContext } from "react";
import { withRouter } from "react-router-dom";
import { Button, Input, Icon, Typography, Dropdown, Menu, Tooltip, message } from "antd";
import { LeftOutlined } from "@ant-design/icons";
import { platformApi } from "../../../api";
import LocalityTable from "./LocalityTable";
import LocalityForm from "./LocalityForm";
import { ContextAPI } from "../../../ContextAPI";

const { Search } = Input;
const { Title } = Typography;
const { Item } = Menu;

const Locality = (props) => {
  const { loginCredintials } = useContext(ContextAPI);
  const [createAccess, setCreateAccess] = useState(true);
  const [modifyAccess, setModifyAccess] = useState(true);

  const [searchString, setSearchString] = useState("");
  const [localities, setLocalities] = useState([]);
  const [count, setCount] = useState(0);
  const [spinner, setSpinner] = useState(false);
  const [currentRecord, setCurrentRecord] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editable, setEditable] = useState(true);
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(1);

  const getMenu = () => {
    let size = count / 10 + (count % 10 ? 1 : 0);
    const menus = [];
    menus.push(10);
    size = size <= 10 ? size : 10;
    for (let itr = 2; itr <= size; itr++) menus.push(itr * 10);
    return menus.map((menu) => (
      <Item
        onClick={() => {
          setLimit(menu);
          setPage(1);
        }}
        key={menu}
      >
        {menu}
      </Item>
    ));
  };

  const menu = <Menu>{getMenu()}</Menu>;

  useEffect(() => {
    if (loginCredintials && loginCredintials.roleAccess) {
      loginCredintials.roleAccess.forEach((each) => {
        if ((each.subModule || "").toLowerCase() === "locality") {
          if (each.access && each.access.create !== undefined) {
            setCreateAccess(each.access.create);
          }
          if (each.access && each.access.update !== undefined) {
            setModifyAccess(each.access.update);
          }
        }
      });
    }
  }, [loginCredintials]);

  useEffect(() => {
    fetchLocalities(page, limit, searchString);
  }, [page, limit, searchString]);

  const fetchLocalities = (p, l, search) => {
    setSpinner(true);
    platformApi
      .post("/api/csc/locality/get", {
        page: p,
        size: l,
        searchString: search,
      })
      .then((res) => {
        setSpinner(false);
        const { data } = res;
        if (data.code === 200) {
          const { response } = data;
          if (response && response.code === 200 && response.data) {
            setLocalities(response.data.localities || []);
            setCount(response.data.count || 0);
          }
        }
      })
      .catch((err) => {
        setSpinner(false);
        console.error("Error fetching localities:", err);
        message.error("Failed to fetch localities");
      });
  };

  const openModal = (id, isEditable = true) => {
    if (id) {
      const selected = localities.find((item) => item.id === id);
      setCurrentRecord(selected || null);
    } else {
      setCurrentRecord(null);
    }
    setEditable(isEditable);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setCurrentRecord(null);
  };

  const emitData = (payload) => {
    if (payload.id) {
      platformApi
        .put(`/api/csc/locality/${payload.id}`, payload)
        .then((res) => {
          if (res.data && res.data.code === 200) {
            message.success("Locality updated successfully");
            fetchLocalities(page, limit, searchString);
          } else {
            message.error(res.data?.message || "Failed to update locality");
          }
        })
        .catch((err) => {
          console.error("Error updating locality:", err);
          message.error("Error updating locality");
        });
    } else {
      platformApi
        .post("/api/csc/locality", payload)
        .then((res) => {
          if (res.data && res.data.code === 200) {
            message.success("Locality created successfully");
            setPage(1);
            fetchLocalities(1, limit, searchString);
          } else {
            message.error(res.data?.message || "Failed to create locality");
          }
        })
        .catch((err) => {
          console.error("Error creating locality:", err);
          message.error("Error creating locality");
        });
    }
  };

  const deleteData = (id) => {
    let temp = page !== 1 && localities.length === 1;
    platformApi
      .delete(`/api/csc/locality/${id}`)
      .then((res) => {
        if (res.data && res.data.code === 200) {
          message.success("Locality deleted successfully");
          if (temp) {
            setPage(1);
            fetchLocalities(1, limit, searchString);
          } else {
            fetchLocalities(page, limit, searchString);
          }
        } else {
          message.error(res.data?.message || "Failed to delete locality");
        }
      })
      .catch((err) => {
        console.error("Error deleting locality:", err);
        message.error("Error deleting locality");
      });
  };

  return (
    <div>
      <div
        className="supplierMaster-top"
        style={{ display: "flex", alignItems: "center", marginBottom: "1.25rem" }}
      >
        <Title style={{ width: "60%" }} level={4}>
          <Tooltip placement="topLeft" title={"Back to Company Master"}>
            <Button
              style={{ margin: "0 20px" }}
              onClick={() => props.history.push("/autoadmin/company")}
            >
              <LeftOutlined />
            </Button>
          </Tooltip>
          Locality Master[{count}]
          <span style={{ marginLeft: "1rem" }}>
            <Dropdown overlay={menu} trigger={["click"]}>
              <Button>
                {limit}
                &nbsp;
                <Icon type="down" />
              </Button>
            </Dropdown>
          </span>
        </Title>
        <Search
          placeholder="Search Locality / Pin Code / City"
          style={{ width: "30%" }}
          onSearch={(event) => {
            setPage(1);
            setSearchString(event);
          }}
          onChange={(event) => {
            if (event.target.value === "") {
              setSearchString("");
              setPage(1);
            }
          }}
        />
        <Button
          type="primary"
          className="add-manufacturer-button"
          onClick={() => openModal(null, true)}
          style={{ margin: "0 3%", width: "14%" }}
          disabled={!createAccess}
        >
          Add Locality
        </Button>
      </div>

      <div style={{ margin: ".5rem" }}>
        <LocalityTable
          dataSource={localities}
          spinner={spinner}
          pagination={{
            onChange: (p) => {
              setPage(p);
            },
            pageSize: limit,
            defaultCurrent: 1,
            total: count,
            current: page,
            showQuickJumper: true,
          }}
          openModal={openModal}
          delete={deleteData}
        />
      </div>

      <LocalityForm
        open={isModalOpen}
        close={closeModal}
        data={currentRecord}
        editable={editable}
        modify={modifyAccess}
        emitData={emitData}
      />
    </div>
  );
};

export default withRouter(Locality);

